import { CSSProperties, ReactNode } from "react"

interface SpanProps {
    fontFamily?: string
    fontSize?: number
    color?: string
    letterSpacing?: number
    fontWeight?: number
    className?: string
    children?: ReactNode
    lineHeight?: number
    style?: CSSProperties
    title?: string
}
const Span = ({fontFamily, fontSize, color, letterSpacing, fontWeight, className, children, lineHeight, style, title}: SpanProps) => {
    return (
        <span
            className={className ? className : ""}
            style={{
                ...style,
                fontVariant: "tabular-nums",
                fontFamily: fontFamily ? fontFamily : "",
                fontSize: fontSize ? fontSize + "px" : "",
                color: color ? color : color,
                letterSpacing: letterSpacing ? letterSpacing + "px" : "",
                fontWeight: fontWeight ? fontWeight : "",
                lineHeight: lineHeight ? lineHeight : ""
            }}
            title={title}
        >
            {children}
        </span>
    )
}
export default Span;